import type {ChatMessage, ModelMessage, RequestConfig, TextPartPurpose} from '@Components/ai-chat-window/ai-chat-window.types';
import type {ALIGNMENT_TYPE} from '@Components/dropdown-v2/dropdown.types';
import type {AiPromptBoxAttachments} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';

export const POSITIVE_FEEDBACK_COUNT_TO_PROMPT_REVIEW = 2;

export interface ResponseFeedbackProps {
  chatId: string;
  message: ModelMessage;
  messages: Record<string, ChatMessage>;
  isMobile?: boolean;
  isNegativeFeedbackTextInputPopupOpen?: boolean;
  onOpenNegativeFeedbackTextInputPopup?: () => void;
  onCloseNegativeFeedbackTextInputPopup?: () => void;
  popupClassname?: string;
  dropdownClassname?: string;
  dropdownPopupAlignment?: ALIGNMENT_TYPE;
  containerClassName?: string;
  areFeedbackOptionsDisabled: boolean;
  onRegenerate: (prompt?: string, requestConfig?: RequestConfig, purpose?: TextPartPurpose) => void;
  onGenerate: (prompt: string, promptAttachments?: AiPromptBoxAttachments, requestConfig?: RequestConfig, purpose?: TextPartPurpose) => Promise<void>;
  onOpenInEditor: () => void;
  imageHashedId: string;
  imageWidth: number;
  imageHeight: number;
  canWrite: boolean;
  isMessageStreaming?: boolean;
}
